var NONAME_R51D_E = {
	name: "NONAME R51D-E",
	defaultCommandIndex: 1,
	commands: [
		{
			mode: "AC_MODE_OFF",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_NULL",
			command: [199,0,5,120,2,253,5,128,2,192,1,164,17,225,16,114,2,11,20,128,2,0,0,55,90,215,111,189,86,189,85,87,226,110,181,174,223,122,173,122,170,175,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,114,2,3,6,130,2,178,1,152,17,230,16,115,2,14,20,116,2,0,0,55,90,215,119,246,170,170,170,191,226,110,181,174,239,237,85,85,85,127,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,113,2,4,6,121,2,179,1,147,17,221,16,112,2,13,20,115,2,0,0,55,90,215,119,246,170,170,213,123,226,110,181,174,239,237,85,85,170,247,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,119,2,3,6,122,2,177,1,135,17,228,16,114,2,13,20,113,2,0,0,55,90,215,119,246,170,171,170,235,226,110,181,174,239,237,85,87,85,215,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,114,2,4,6,122,2,189,1,140,17,222,16,114,2,11,20,112,2,0,0,55,90,215,119,246,170,171,85,119,226,110,181,174,239,237,85,86,170,239,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,135,2,238,5,135,2,176,1,139,17,222,16,137,2,5,20,139,2,0,0,55,90,215,119,246,170,174,170,215,226,110,181,174,239,237,85,93,85,175,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,106,2,13,6,139,2,165,1,134,17,225,16,114,2,27,20,102,2,0,0,55,90,215,119,246,170,175,85,171,226,110,181,174,239,237,85,94,171,87,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,142,2,236,5,142,2,151,1,134,17,239,16,143,2,3,20,142,2,0,0,55,90,215,119,246,170,173,170,219,226,110,181,174,239,237,85,91,85,183,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,140,2,234,5,142,2,155,1,136,17,214,16,140,2,3,20,140,2,0,0,55,90,215,119,246,170,173,85,111,226,110,181,174,239,237,85,90,170,223,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,141,2,233,5,144,2,166,1,132,17,227,16,142,2,255,19,140,2,0,0,55,90,215,119,246,170,186,170,175,226,110,181,174,239,237,85,117,85,95,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,131,2,245,5,143,2,156,1,133,17,228,16,125,2,17,20,123,2,0,0,55,90,215,119,246,170,187,85,91,226,110,181,174,239,237,85,118,170,183,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,142,2,233,5,143,2,160,1,140,17,233,16,143,2,0,20,141,2,0,0,55,90,215,119,246,170,181,170,187,226,110,181,174,239,237,85,107,85,119,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,139,2,234,5,153,2,165,1,129,17,214,16,138,2,2,20,140,2,0,0,55,90,215,119,246,170,181,85,95,226,110,181,174,239,237,85,106,170,191,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,142,2,231,5,147,2,169,1,127,17,230,16,143,2,255,19,143,2,0,0,55,90,215,119,246,170,182,170,183,226,110,181,174,239,237,85,109,85,111,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [199,0,8,137,2,175,1,155,2,216,5,99,2,247,6,127,1,213,1,116,1,166,6,234,16,128,17,185,2,219,19,168,2,0,0,4,34,167,35,78,166,66,36,33,33,34,71,228,72,71,221,42,129,5,165,211,186,90,210,170,211,251,95,186,85],
		},
		///////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [199,0,5,124,2,249,5,153,2,156,1,134,17,218,16,101,2,40,20,121,2,0,0,55,90,215,117,251,170,170,170,191,226,110,181,174,235,247,85,85,85,127,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [199,0,5,117,2,4,6,122,2,175,1,147,17,220,16,118,2,11,20,116,2,0,0,55,90,215,117,251,170,170,213,123,226,110,181,174,235,247,85,85,170,247,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [199,0,5,135,2,241,5,149,2,151,1,135,17,235,16,137,2,7,20,137,2,0,0,55,90,215,117,251,170,171,170,235,226,110,181,174,235,247,85,87,85,215,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [199,0,5,138,2,236,5,141,2,170,1,146,17,223,16,139,2,2,20,141,2,0,0,55,90,215,117,251,170,171,85,119,226,110,181,174,235,247,85,86,170,239,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [199,0,5,138,2,235,5,150,2,163,1,134,17,229,16,130,2,11,20,135,2,0,0,55,90,215,117,251,170,174,170,215,226,110,181,174,235,247,85,93,85,175,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [199,0,5,138,2,236,5,140,2,162,1,131,17,218,16,139,2,251,19,138,2,0,0,55,90,215,117,251,170,175,85,171,226,110,181,174,235,247,85,94,171,87,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [199,0,8,158,2,211,5,149,2,167,1,105,1,236,1,103,1,15,7,220,16,132,17,135,1,235,5,168,2,226,19,170,2,0,0,8,144,84,165,18,37,17,17,34,85,82,85,183,192,134,235,90,238,191,117,85,181,91,124],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [199,0,5,141,2,229,5,143,2,152,1,132,17,227,16,143,2,245,19,141,2,0,0,55,90,215,117,251,170,173,85,111,226,110,181,174,235,247,85,90,170,223,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [199,0,5,142,2,229,5,148,2,161,1,125,17,228,16,141,2,249,19,144,2,0,0,55,90,215,117,251,170,186,170,175,226,110,181,174,235,247,85,117,85,95,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [199,0,5,140,2,233,5,144,2,151,1,124,17,223,16,140,2,252,19,136,2,0,0,55,90,215,117,251,170,187,85,91,226,110,181,174,235,247,85,118,170,183,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [199,0,5,125,2,246,5,139,2,162,1,127,17,222,16,124,2,7,20,124,2,0,0,55,90,215,117,251,170,181,170,187,226,110,181,174,235,247,85,107,85,119,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [199,0,5,142,2,229,5,152,2,167,1,130,17,231,16,144,2,245,19,139,2,0,0,55,90,215,117,251,170,181,85,95,226,110,181,174,235,247,85,106,170,191,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [199,0,5,109,2,7,6,126,2,186,1,130,17,224,16,100,2,34,20,103,2,0,0,55,90,215,117,251,170,182,170,183,226,110,181,174,235,247,85,109,85,111,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [199,0,5,135,2,238,5,147,2,153,1,156,17,189,16,135,2,1,20,133,2,0,0,55,90,215,117,251,170,183,85,107,226,110,181,174,235,247,85,110,170,215,192],
		},
		/////////////////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [199,0,5,138,2,234,5,143,2,167,1,130,17,228,16,141,2,252,19,139,2,0,0,55,90,215,109,253,170,170,170,191,226,110,181,174,219,251,85,85,85,127,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [199,0,5,118,2,254,5,126,2,169,1,141,17,212,16,118,2,1,20,117,2,0,0,55,90,215,109,253,170,170,213,123,226,110,181,174,219,251,85,85,170,247,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [199,0,5,123,2,250,5,130,2,165,1,153,17,203,16,121,2,10,20,123,2,0,0,55,90,215,109,253,170,171,170,235,226,110,181,174,219,251,85,87,85,215,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [199,0,5,133,2,238,5,140,2,168,1,146,17,203,16,125,2,9,20,132,2,0,0,55,90,215,109,253,170,171,85,119,226,110,181,174,219,251,85,86,170,239,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [199,0,5,134,2,237,5,148,2,163,1,126,17,226,16,137,2,254,19,133,2,0,0,55,90,215,109,253,170,174,170,215,226,110,181,174,219,251,85,93,85,175,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [199,0,5,140,2,233,5,143,2,159,1,133,17,220,16,139,2,252,19,140,2,0,0,55,90,215,109,253,170,175,85,171,226,110,181,174,219,251,85,94,171,87,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [199,0,5,136,2,237,5,134,2,154,1,153,17,211,16,135,2,254,19,135,2,0,0,55,90,215,109,253,170,173,170,219,226,110,181,174,219,251,85,91,85,183,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [199,0,5,136,2,236,5,139,2,156,1,136,17,215,16,137,2,253,19,134,2,0,0,55,90,215,109,253,170,173,85,111,226,110,181,174,219,251,85,90,170,223,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [199,0,5,140,2,231,5,143,2,165,1,126,17,226,16,137,2,252,19,140,2,0,0,55,90,215,109,253,170,186,170,175,226,110,181,174,219,251,85,117,85,95,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [199,0,5,131,2,243,5,137,2,159,1,142,17,205,16,129,2,4,20,131,2,0,0,55,90,215,109,253,170,187,85,91,226,110,181,174,219,251,85,118,170,183,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [199,0,5,136,2,236,5,137,2,160,1,150,17,199,16,134,2,255,19,136,2,0,0,55,90,215,109,253,170,181,170,187,226,110,181,174,219,251,85,107,85,119,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [199,0,5,124,2,248,5,135,2,183,1,155,17,206,16,125,2,8,20,123,2,0,0,55,90,215,109,253,170,181,85,95,226,110,181,174,219,251,85,106,170,191,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [199,0,5,116,2,255,5,121,2,199,1,146,17,211,16,114,2,4,20,114,2,0,0,55,90,215,109,253,170,182,170,183,226,110,181,174,219,251,85,109,85,111,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [199,0,5,134,2,238,5,146,2,157,1,146,17,206,16,134,2,1,20,134,2,0,0,55,90,215,109,253,170,183,85,107,226,110,181,174,219,251,85,110,170,215,192],
		},
		/////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,140,2,230,5,125,2,184,1,141,17,220,16,141,2,244,19,147,2,0,0,55,90,215,107,254,170,170,170,191,226,110,181,174,215,253,85,85,85,127,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,103,2,14,6,115,2,180,1,133,17,213,16,101,2,18,20,97,2,0,0,55,90,215,107,254,170,170,213,123,226,110,181,174,215,253,85,85,170,247,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,115,2,2,6,143,2,156,1,129,17,225,16,115,2,22,20,108,2,0,0,55,90,215,107,254,170,171,170,235,226,110,181,174,215,253,85,87,85,215,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,106,2,8,6,126,2,182,1,128,17,218,16,111,2,23,20,106,2,0,0,55,90,215,107,254,170,171,85,119,226,110,181,174,215,253,85,86,170,239,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,138,2,233,5,137,2,175,1,124,17,225,16,139,2,249,19,139,2,0,0,55,90,215,107,254,170,174,170,215,226,110,181,174,215,253,85,93,85,175,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,140,2,231,5,143,2,159,1,121,17,229,16,142,2,249,19,138,2,0,0,55,90,215,107,254,170,175,85,171,226,110,181,174,215,253,85,94,171,87,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,134,2,239,5,134,2,156,1,134,17,215,16,133,2,0,20,135,2,0,0,55,90,215,107,254,170,173,170,219,226,110,181,174,215,253,85,91,85,183,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,138,2,234,5,137,2,158,1,125,17,222,16,140,2,248,19,136,2,0,0,55,90,215,107,254,170,173,85,111,226,110,181,174,215,253,85,90,170,223,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,138,2,233,5,141,2,168,1,131,17,208,16,138,2,251,19,138,2,0,0,55,90,215,107,254,170,186,170,175,226,110,181,174,215,253,85,117,85,95,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,103,2,15,6,122,2,172,1,127,17,216,16,110,2,26,20,101,2,0,0,55,90,215,107,254,170,187,85,91,226,110,181,174,215,253,85,118,170,183,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,149,2,218,5,141,2,179,1,83,17,20,17,152,2,247,19,156,2,0,0,55,90,215,107,254,170,181,170,187,226,110,181,174,215,253,85,107,85,119,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,115,2,4,6,129,2,190,1,142,17,227,16,113,2,17,20,114,2,0,0,55,90,215,107,254,170,181,85,95,226,110,181,174,215,253,85,106,170,191,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,127,2,246,5,140,2,175,1,128,17,226,16,125,2,12,20,129,2,0,0,55,90,215,107,254,170,182,170,183,226,110,181,174,215,253,85,109,85,111,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,131,2,242,5,142,2,156,1,151,17,206,16,133,2,4,20,130,2,0,0,55,90,215,107,254,170,183,85,107,226,110,181,174,215,253,85,110,170,215,192],
		},
		//////////////////////////HEAT///////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,135,2,242,5,137,2,176,1,139,17,221,16,137,2,2,20,137,2,0,0,55,90,215,119,246,170,170,186,250,226,110,181,174,239,237,85,85,117,245,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,141,2,234,5,143,2,174,1,122,17,232,16,140,2,1,20,142,2,0,0,55,90,215,119,246,170,170,245,234,226,110,181,174,239,237,85,85,235,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [199,0,7,142,2,224,5,112,2,208,1,125,2,205,1,216,1,57,6,8,17,99,17,161,2,235,19,160,2,0,0,8,233,77,41,165,59,167,244,210,148,165,41,74,120,165,58,82,148,224,134,157,41,165,52,167,78,159,211,74,82,148,165,41,244,167,74,82,156],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,136,2,228,5,124,2,199,1,98,17,11,17,151,2,245,19,151,2,0,0,55,90,215,119,246,170,171,117,218,226,110,181,174,239,237,85,86,235,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,142,2,236,5,142,2,171,1,130,17,229,16,142,2,253,19,139,2,0,0,55,90,215,119,246,170,174,235,90,226,110,181,174,239,237,85,93,214,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,135,2,249,5,136,2,168,1,177,17,206,16,136,2,8,20,133,2,0,0,55,90,215,119,246,170,175,214,170,226,110,181,174,239,237,85,95,173,85,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,137,2,237,5,141,2,178,1,131,17,232,16,141,2,0,20,141,2,0,0,55,90,215,119,246,170,173,235,106,226,110,181,174,239,237,85,91,214,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,142,2,234,5,144,2,170,1,130,17,235,16,143,2,254,19,142,2,0,0,55,90,215,119,246,170,173,117,186,226,110,181,174,239,237,85,90,235,117,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,144,2,233,5,145,2,171,1,128,17,231,16,145,2,253,19,142,2,0,0,55,90,215,119,246,170,186,234,186,226,110,181,174,239,237,85,117,213,117,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,121,2,1,6,130,2,187,1,141,17,214,16,115,2,7,20,115,2,0,0,55,90,215,119,246,170,187,213,106,226,110,181,174,239,237,85,119,170,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,144,2,231,5,151,2,167,1,133,17,228,16,141,2,255,19,141,2,0,0,55,90,215,119,246,170,181,234,234,226,110,181,174,239,237,85,107,213,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,143,2,234,5,147,2,167,1,128,17,232,16,143,2,1,20,140,2,0,0,55,90,215,119,246,170,181,117,122,226,110,181,174,239,237,85,106,234,245,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,144,2,238,5,143,2,167,1,135,17,229,16,140,2,0,20,140,2,0,0,55,90,215,119,246,170,182,234,218,226,110,181,174,239,237,85,109,213,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,136,2,244,5,134,2,182,1,151,17,213,16,134,2,11,20,133,2,0,0,55,90,215,119,246,170,183,213,170,226,110,181,174,239,237,85,111,171,85,192],
		},
		///////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [199,0,5,130,2,247,5,145,2,167,1,143,17,228,16,118,2,25,20,119,2,0,0,55,90,215,117,251,170,170,186,250,226,110,181,174,235,247,85,85,117,245,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [199,0,5,134,2,241,5,150,2,166,1,135,17,205,16,117,2,24,20,121,2,0,0,55,90,215,117,251,170,170,245,234,226,110,181,174,235,247,85,85,235,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [199,0,5,139,2,238,5,141,2,177,1,143,17,232,16,141,2,3,20,138,2,0,0,55,90,215,117,251,170,171,235,170,226,110,181,174,235,247,85,87,215,85,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [199,0,5,138,2,243,5,137,2,174,1,142,17,230,16,135,2,9,20,135,2,0,0,55,90,215,117,251,170,171,117,218,226,110,181,174,235,247,85,86,235,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [199,0,5,146,2,233,5,147,2,166,1,148,17,232,16,145,2,251,19,142,2,0,0,55,90,215,117,251,170,174,235,90,226,110,181,174,235,247,85,93,214,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [199,0,5,121,2,1,6,127,2,185,1,144,17,225,16,114,2,14,20,115,2,0,0,55,90,215,117,251,170,175,214,170,226,110,181,174,235,247,85,95,173,85,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [199,0,5,145,2,230,5,151,2,168,1,142,17,236,16,144,2,253,19,145,2,0,0,55,90,215,117,251,170,173,235,106,226,110,181,174,235,247,85,91,214,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [199,0,5,142,2,236,5,144,2,169,1,131,17,233,16,143,2,255,19,140,2,0,0,55,90,215,117,251,170,173,117,186,226,110,181,174,235,247,85,90,235,117,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [199,0,5,134,2,243,5,145,2,169,1,135,17,232,16,122,2,21,20,123,2,0,0,55,90,215,117,251,170,186,234,186,226,110,181,174,235,247,85,117,213,117,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [199,0,5,119,2,2,6,128,2,191,1,145,17,227,16,114,2,9,20,116,2,0,0,55,90,215,117,251,170,187,213,106,226,110,181,174,235,247,85,119,170,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [199,0,5,138,2,237,5,142,2,175,1,137,17,228,16,142,2,255,19,139,2,0,0,55,90,215,117,251,170,181,234,234,226,110,181,174,235,247,85,107,213,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [199,0,5,143,2,233,5,149,2,166,1,131,17,232,16,142,2,0,20,144,2,0,0,55,90,215,117,251,170,181,117,122,226,110,181,174,235,247,85,106,234,245,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [199,0,5,120,2,5,6,103,2,199,1,146,17,218,16,99,2,24,20,101,2,0,0,55,90,215,117,251,170,182,234,218,226,110,181,174,235,247,85,109,213,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [199,0,5,121,2,4,6,132,2,186,1,156,17,224,16,117,2,241,19,115,2,0,0,55,90,215,117,251,170,183,213,170,226,110,181,174,235,247,85,111,171,85,192],
		},
		//////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [199,0,5,125,2,255,5,130,2,179,1,158,17,219,16,119,2,16,20,120,2,0,0,55,90,215,109,253,170,170,186,250,226,110,181,174,219,251,85,85,117,245,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [199,0,5,119,2,0,6,128,2,189,1,148,17,222,16,116,2,11,20,114,2,0,0,55,90,215,109,253,170,170,245,234,226,110,181,174,219,251,85,85,235,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [199,0,5,146,2,231,5,152,2,164,1,132,17,232,16,143,2,254,19,137,2,0,0,55,90,215,109,253,170,171,235,170,226,110,181,174,219,251,85,87,215,85,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [199,0,5,120,2,4,6,118,2,191,1,139,17,215,16,99,2,28,20,99,2,0,0,55,90,215,109,253,170,171,117,218,226,110,181,174,219,251,85,86,235,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [199,0,5,121,2,2,6,120,2,191,1,135,17,221,16,110,2,22,20,102,2,0,0,55,90,215,109,253,170,174,235,90,226,110,181,174,219,251,85,93,214,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [199,0,5,138,2,235,5,153,2,167,1,143,17,222,16,147,2,255,19,137,2,0,0,55,90,215,109,253,170,175,214,170,226,110,181,174,219,251,85,95,173,85,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [199,0,5,135,2,239,5,134,2,182,1,152,17,203,16,135,2,3,20,137,2,0,0,55,90,215,109,253,170,173,235,106,226,110,181,174,219,251,85,91,214,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [199,0,5,140,2,223,5,123,2,203,1,76,17,255,16,154,2,248,19,152,2,0,0,55,90,215,109,253,170,173,117,186,226,110,181,174,219,251,85,90,235,117,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [199,0,5,119,2,2,6,141,2,174,1,130,17,221,16,108,2,31,20,102,2,0,0,55,90,215,109,253,170,186,234,186,226,110,181,174,219,251,85,117,213,117,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [199,0,5,141,2,233,5,145,2,172,1,128,17,234,16,144,2,249,19,142,2,0,0,55,90,215,109,253,170,187,213,106,226,110,181,174,219,251,85,119,170,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [199,0,5,144,2,216,5,112,2,210,1,129,17,251,16,158,2,234,19,174,2,0,0,55,90,215,109,253,170,181,234,234,226,110,181,174,219,251,85,107,213,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [199,0,5,138,2,237,5,151,2,164,1,133,17,223,16,134,2,7,20,140,2,0,0,55,90,215,109,253,170,181,117,122,226,110,181,174,219,251,85,106,234,245,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [199,0,5,140,2,238,5,139,2,170,1,131,17,228,16,140,2,255,19,141,2,0,0,55,90,215,109,253,170,182,234,218,226,110,181,174,219,251,85,109,213,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [199,0,5,134,2,245,5,137,2,180,1,152,17,208,16,129,2,10,20,130,2,0,0,55,90,215,109,253,170,183,213,170,226,110,181,174,219,251,85,111,171,85,192],
		},
		//////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,131,2,242,5,138,2,174,1,150,17,204,16,133,2,1,20,132,2,0,0,55,90,215,107,254,170,170,186,250,226,110,181,174,215,253,85,85,117,245,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,139,2,234,5,137,2,176,1,128,17,222,16,139,2,253,19,138,2,0,0,55,90,215,107,254,170,170,245,234,226,110,181,174,215,253,85,85,235,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,131,2,245,5,140,2,176,1,144,17,211,16,128,2,6,20,128,2,0,0,55,90,215,107,254,170,171,235,170,226,110,181,174,215,253,85,87,215,85,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,136,2,228,5,125,2,196,1,105,17,248,16,153,2,237,19,154,2,0,0,55,90,215,107,254,170,171,117,218,226,110,181,174,215,253,85,86,235,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,142,2,235,5,143,2,169,1,121,17,230,16,142,2,248,19,138,2,0,0,55,90,215,107,254,170,174,235,90,226,110,181,174,215,253,85,93,214,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,139,2,233,5,145,2,173,1,126,17,230,16,140,2,249,19,141,2,0,0,55,90,215,107,254,170,175,214,170,226,110,181,174,215,253,85,95,173,85,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,145,2,228,5,149,2,166,1,122,17,225,16,140,2,249,19,143,2,0,0,55,90,215,107,254,170,173,235,106,226,110,181,174,215,253,85,91,214,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,129,2,247,5,137,2,172,1,146,17,207,16,129,2,6,20,128,2,0,0,55,90,215,107,254,170,173,117,186,226,110,181,174,215,253,85,90,235,117,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,128,2,247,5,146,2,166,1,130,17,229,16,129,2,13,20,104,2,0,0,55,90,215,107,254,170,186,234,186,226,110,181,174,215,253,85,117,213,117,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,133,2,240,5,137,2,182,1,147,17,200,16,134,2,255,19,133,2,0,0,55,90,215,107,254,170,187,213,106,226,110,181,174,215,253,85,119,170,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,140,2,232,5,150,2,165,1,128,17,225,16,122,2,10,20,133,2,0,0,55,90,215,107,254,170,181,234,234,226,110,181,174,215,253,85,107,213,213,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,136,2,238,5,143,2,171,1,130,17,223,16,138,2,251,19,136,2,0,0,55,90,215,107,254,170,181,117,122,226,110,181,174,215,253,85,106,234,245,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,121,2,7,6,122,2,186,1,141,17,225,16,113,2,15,20,114,2,0,0,55,90,215,107,254,170,182,234,218,226,110,181,174,215,253,85,109,213,181,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,137,2,238,5,139,2,177,1,126,17,227,16,137,2,251,19,136,2,0,0,55,90,215,107,254,170,183,213,170,226,110,181,174,215,253,85,111,171,85,192],
		},
		///////////////////////////DRY////////////////////////////////
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_NULL",
			command: [199,0,5,128,2,247,5,128,2,183,1,132,17,218,16,116,2,26,20,114,2,0,0,55,90,215,106,255,170,170,173,126,226,110,181,174,213,255,85,85,90,253,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_NULL",
			command: [199,0,5,137,2,238,5,135,2,175,1,152,17,209,16,137,2,3,20,133,2,0,0,55,90,215,106,255,170,170,218,246,226,110,181,174,213,255,85,85,181,237,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_NULL",
			command: [199,0,5,137,2,241,5,138,2,174,1,142,17,230,16,139,2,4,20,139,2,0,0,55,90,215,106,255,170,171,181,214,226,110,181,174,213,255,85,87,107,173,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_NULL",
			command: [199,0,5,144,2,232,5,141,2,164,1,132,17,217,16,144,2,255,19,140,2,0,0,55,90,215,106,255,170,171,90,238,226,110,181,174,213,255,85,86,181,221,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_NULL",
			command: [199,0,5,140,2,236,5,139,2,170,1,144,17,225,16,140,2,2,20,139,2,0,0,55,90,215,106,255,170,174,181,174,226,110,181,174,213,255,85,93,107,93,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_NULL",
			command: [199,0,5,137,2,240,5,135,2,179,1,155,17,212,16,139,2,3,20,136,2,0,0,55,90,215,106,255,170,175,107,86,226,110,181,174,213,255,85,94,214,173,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_NULL",
			command: [199,0,5,136,2,243,5,130,2,176,1,148,17,208,16,125,2,13,20,129,2,0,0,55,90,215,106,255,170,173,181,182,226,110,181,174,213,255,85,91,107,109,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_NULL",
			command: [199,0,5,131,2,246,5,127,2,174,1,151,17,210,16,130,2,11,20,127,2,0,0,55,90,215,106,255,170,173,90,222,226,110,181,174,213,255,85,90,181,189,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_NULL",
			command: [199,0,5,126,2,251,5,131,2,175,1,165,17,212,16,121,2,20,20,123,2,0,0,55,90,215,106,255,170,186,181,94,226,110,181,174,213,255,85,117,106,189,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_NULL",
			command: [199,0,5,137,2,241,5,134,2,175,1,149,17,210,16,131,2,8,20,130,2,0,0,55,90,215,106,255,170,187,106,182,226,110,181,174,213,255,85,118,213,109,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_NULL",
			command: [199,0,5,126,2,251,5,126,2,184,1,138,17,212,16,122,2,20,20,121,2,0,0,55,90,215,106,255,170,181,181,118,226,110,181,174,213,255,85,107,106,237,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_NULL",
			command: [199,0,5,136,2,237,5,137,2,179,1,134,17,226,16,138,2,2,20,139,2,0,0,55,90,215,106,255,170,181,90,190,226,110,181,174,213,255,85,106,181,125,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_NULL",
			command: [199,0,5,126,2,251,5,127,2,179,1,145,17,212,16,125,2,16,20,122,2,0,0,55,90,215,106,255,170,182,181,110,226,110,181,174,213,255,85,109,106,221,192],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_NULL",
			command: [199,0,5,137,2,241,5,134,2,177,1,153,17,209,16,134,2,6,20,135,2,0,0,55,90,215,106,255,170,183,106,214,226,110,181,174,213,255,85,110,213,173,192],
		},
		/////////////////////////AUTO////////////////////////
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_NULL",
			command: [199,0,5,115,2,3,6,121,2,175,1,142,17,222,16,114,2,12,20,119,2,0,0,55,90,215,106,255,170,170,181,125,226,110,181,174,213,255,85,85,106,251,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_NULL",
			command: [199,0,5,134,2,242,5,138,2,166,1,153,17,198,16,127,2,19,20,130,2,0,0,55,90,215,106,255,170,170,234,245,226,110,181,174,213,255,85,85,213,235,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_NULL",
			command: [199,0,5,136,2,241,5,145,2,161,1,167,17,214,16,135,2,8,20,133,2,0,0,55,90,215,106,255,170,171,213,213,226,110,181,174,213,255,85,87,171,171,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_NULL",
			command: [199,0,5,128,2,250,5,130,2,160,1,145,17,219,16,127,2,16,20,130,2,0,0,55,90,215,106,255,170,171,106,237,226,110,181,174,213,255,85,86,213,219,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_NULL",
			command: [199,0,5,140,2,237,5,139,2,158,1,138,17,230,16,141,2,4,20,137,2,0,0,55,90,215,106,255,170,174,213,173,226,110,181,174,213,255,85,93,171,91,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_NULL",
			command: [199,0,5,105,2,14,6,141,2,168,1,136,17,231,16,107,2,36,20,100,2,0,0,55,90,215,106,255,170,175,171,85,226,110,181,174,213,255,85,95,86,171,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_NULL",
			command: [199,0,5,139,2,236,5,141,2,167,1,135,17,211,16,140,2,0,20,141,2,0,0,55,90,215,106,255,170,173,213,181,226,110,181,174,213,255,85,91,171,107,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_NULL",
			command: [199,0,5,140,2,236,5,141,2,150,1,137,17,227,16,142,2,255,19,141,2,0,0,55,90,215,106,255,170,173,106,221,226,110,181,174,213,255,85,90,213,187,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_NULL",
			command: [199,0,5,136,2,240,5,143,2,154,1,142,17,218,16,138,2,1,20,137,2,0,0,55,90,215,106,255,170,186,213,93,226,110,181,174,213,255,85,117,170,187,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_NULL",
			command: [199,0,5,134,2,241,5,138,2,170,1,149,17,208,16,137,2,4,20,134,2,0,0,55,90,215,106,255,170,187,170,181,226,110,181,174,213,255,85,119,85,107,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_NULL",
			command: [199,0,5,136,2,239,5,144,2,166,1,153,17,208,16,136,2,2,20,135,2,0,0,55,90,215,106,255,170,181,213,117,226,110,181,174,213,255,85,107,170,235,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_NULL",
			command: [199,0,5,122,2,255,5,128,2,175,1,149,17,218,16,122,2,9,20,120,2,0,0,55,90,215,106,255,170,181,106,189,226,110,181,174,213,255,85,106,213,123,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_NULL",
			command: [199,0,5,143,2,233,5,146,2,149,1,128,17,234,16,145,2,251,19,141,2,0,0,55,90,215,106,255,170,182,213,109,226,110,181,174,213,255,85,109,170,219,192],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_NULL",
			command: [199,0,5,102,2,19,6,131,2,176,1,138,17,211,16,99,2,35,20,98,2,0,0,55,90,215,106,255,170,183,170,213,226,110,181,174,213,255,85,111,85,171,192],
		},
		/////////////////////////FAN///////////////////////////////
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_AUTO",
			command: [199,0,5,138,2,238,5,140,2,171,1,141,17,225,16,140,2,3,20,141,2,0,0,55,90,215,119,246,170,189,106,174,226,110,181,174,239,237,85,122,213,93,192],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_LOW",
			command: [199,0,5,142,2,233,5,145,2,167,1,132,17,235,16,143,2,1,20,141,2,0,0,55,90,215,117,251,170,189,106,174,226,110,181,174,235,247,85,122,213,93,192],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_MID",
			command: [199,0,5,142,2,234,5,143,2,168,1,130,17,237,16,139,2,4,20,141,2,0,0,55,90,215,109,253,170,189,106,174,226,110,181,174,219,251,85,122,213,93,192],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_HIGH",
			command: [199,0,5,134,2,242,5,137,2,175,1,149,17,210,16,129,2,12,20,132,2,0,0,55,90,215,107,254,170,189,106,174,226,110,181,174,215,253,85,122,213,93,192],
		},
		////////////////////////////////////////////////////////////////
	]
};

export default NONAME_R51D_E